import { render, staticRenderFns } from "./convenientEntrance.vue?vue&type=template&id=35f1990e&scoped=true"
import script from "./convenientEntrance.vue?vue&type=script&lang=js"
export * from "./convenientEntrance.vue?vue&type=script&lang=js"
import style0 from "./convenientEntrance.vue?vue&type=style&index=0&id=35f1990e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1990e",
  null
  
)

export default component.exports